import { saveDraft, transitionToNextStep } from 'launch/actions/designBriefActions';
import BriefStore from 'launch/stores/BriefStore';
import DraftStore from 'launch/stores/DraftStore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import UserStore from 'launch/stores/UserStore';
import connectToStores from 'fluxible-addons-react/connectToStores';
import debounce from 'common/utils/debounce';

const provideBriefStep = Brief => {
    class BriefStep extends Component {
        static contextTypes = {
            executeAction: PropTypes.func.isRequired,
        };

        static propTypes = {
            hasAiPreference: PropTypes.bool,
            hasStockQuestion: PropTypes.bool,
            brief: PropTypes.object.isRequired,
            industryOptions: PropTypes.array,
            isLoggedIn: PropTypes.bool.isRequired,
            languageOptions: PropTypes.array,
        };

        static defaultProps = {
            hasAiPreference: false,
            hasStockQuestion: false,
            industryOptions: null,
            languageOptions: null,
        };

        constructor(props) {
            super(props);
            this.state = {};
            this.debouncedSave = debounce(this.saveUpdatedFields, 300);
        }

        handleContinue = () => {
            this.context.executeAction(transitionToNextStep, {
                saveAction: saveDraft,
                data: this.state,
            });
        };

        handleSave = () => {
            if (!this.props.isLoggedIn) {
                window.location.assign(
                    `/signup?source=contests_launch&role=customer&target=${
                        window.location.href
                    }&skip-transition=true`
                );
                return;
            }
            this.saveUpdatedFields({ notify: true });
        };

        saveUpdatedFields = (options = {}) => {
            this.context.executeAction(saveDraft, {
                data: this.state,
                options,
            });
        };

        onChange = (field, value) => {
            this.setState({ [field]: value });
            this.debouncedSave();
        };

        render() {
            let { brief, ...props } = this.props;
            props = {
                ...props,
                ...brief,
                ...this.state,
                onChange: this.onChange,
                onContinue: this.handleContinue,
                onSave: this.handleSave,
                isSaving: this.props.isLoggedIn && this.props.saveInProgress,
            };
            return <Brief {...props} />;
        }
    }

    return connectToStores(BriefStep, [BriefStore, DraftStore, UserStore], function(
        context,
        props
    ) {
        const store = context.getStore(BriefStore);
        const userStore = context.getStore(UserStore);

        return {
            isLoggedIn: userStore.loggedIn,
            hasAiPreference: store.hasAiPreference,
            hasStockQuestion: store.hasStockQuestion,
            languageOptions: store.languageOptions,
            industryOptions: store.industryOptions,
            categoryKey: context.getStore(DraftStore).categoryKey,
            brief: store.briefData,
            ...context.getStore(DraftStore).getState(),
        };
    });
};

export default provideBriefStep;
